<template>
	<div class="row">
		<div class="col-md-12">
			<media-manager
				@reload="reload"
				:user="user"
				:isAuth="isAuth"
				:medias="docs"
				:dropzone="dropzone">
			</media-manager>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import MediaManager from '@/components/MediaManager/layout/MediaManager.vue'

	export default {
		props: ['user', 'isAuth', 'item'],
		components: {
			'media-manager': MediaManager,
		},
		data () {
			return {
				loading: false,

				docs: null,
				dropzone: {
					accepted: this.$env.ACCEPTED_DROPZONE_DOCS,
					url: process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/projects/projects/' + this.item.id,
					maxFileSizeInMB: this.$env.MAXFILESIZE_DROPZONE,
					maxNumberOfFiles: null,
				},
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getDocs()
			},
			reload() {
				this.$emit('reload')
				this.getDocs()
			},
			reloadMedia() {
				this.getDocs()
			},
			getDocs() {
				if(this.item) {
					this.$http.get('admin/projects/projects/' + this.item.id + '/media/media')
					.then(response => {
						this.docs = response.body
					}).catch(response => {
						console.log(response)
					})
				}
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Docs.vue